import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const ListWrapper = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      `repeat(auto-fill, minmax(400px, 1fr))`,
    ],
    gridGap: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
    width: '100%',
    marginBottom: '32px',
  }),
);

export const LinkWrapper = styled.div(() =>
  mq({
    display: 'block',
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.m} ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.m} ${defaultTheme.spacing.s}`,
      `${defaultTheme.spacing.l} ${defaultTheme.spacing.xxl}`,
      `${defaultTheme.spacing.l} ${defaultTheme.spacing.xxl}`,
    ],
    marginBottom: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const VelodromeLink = styled(Link)(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);
